export default [
  {
    path: '/app/promissories',
    name: 'Promissories',
    component: () => import('@/views/Admin/Promissories/Index.vue'),
    meta: {
      pageTitle: 'Çek & Senet',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_PROMISSORIES',
      action: 'read',
    },
  },
  {
    path: '/app/promissories/add',
    name: 'PromissoryAdd',
    component: () => import('@/views/Admin/Promissories/Add.vue'),
    meta: {
      pageTitle: 'Çek & Senet',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/promissories',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_PROMISSORIES',
      action: 'read',
    },
  },
  {
    path: '/app/promissories/edit/:id',
    name: 'PromissoryEdit',
    component: () => import('@/views/Admin/Promissories/Edit.vue'),
    meta: {
      pageTitle: 'Çek & Senet',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/promissories',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_PROMISSORIES',
      action: 'read',
    },
  },
  {
    path: '/app/promissories/view/:id',
    name: 'PromissoryView',
    component: () => import('@/views/Admin/Promissories/View.vue'),
    meta: {
      pageTitle: 'Çek & Senet',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/promissories',
          active: false,
        },
        {
          text: 'Görüntüle',
          active: true,
        },
      ],
      resource: 'ADMIN_PROMISSORIES',
      action: 'read',
    },
  },
]
